module.exports = __webpack_public_path__ + "ba76de90520f5c8355c2a91b63e69396.webm";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/teaser-1080.webm
// module id = 652
// module chunks = 0